import { leagueCategory } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const leagueCategoryDictionary = createSimpleDictionary([
    { id: leagueCategory.International, name: 'dictionaries.clCategory.international' },
    { id: leagueCategory.DomesticLeague, name: 'dictionaries.clCategory.domesticLeague' },
    { id: leagueCategory.InternationalFriendly, name: 'dictionaries.clCategory.internationalFriendly' },
    { id: leagueCategory.ClubFriendly, name: 'dictionaries.clCategory.clubFriendly' },
    { id: leagueCategory.DomesticCup, name: 'dictionaries.clCategory.domesticCup' },
    { id: leagueCategory.ClubInternational, name: 'dictionaries.clCategory.clubInternational' },
]);
